export default __webpack_public_path__ + "static/media/slipfree.06ad4870.png";